export default __webpack_public_path__ + "images/touch-icon.png?673a7f78e414b4f5f566bb236d81ccf8";